import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useShowroomLocator, {
  validateZipcodeInput,
} from 'hooks/useShowroomLocator';
import ShowroomLocatorResults from './ShowroomLocatorResults';

const ShowroomLocatorContent = ({
  inputId = 'showroom-zipcode',
  className = '',
  isMobile = false,
}) => {
  const zipInputRef = useRef();
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll,
  } = useShowroomLocator();

  return (
    <div className={className}>
      <Formik
        initialValues={{ zipcode: '' }}
        validate={validateZipcodeInput}
        onSubmit={({ zipcode }) => {
          handleSearch(zipcode);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <LabeledTextInput
              id={inputId}
              name="zipcode"
              label="Zip Code"
              type="text"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              errorMessage={
                touched.zipcode && errors.zipcode ? errors.zipcode : null
              }
              maxLength="5"
              autoComplete="postal-code"
              ref={zipInputRef}
              className="text-sm mb-1"
              action={
                <CtaButton
                  type="submit"
                  styling="solid-button"
                  color="brand"
                  size="sm"
                  className="ml-2"
                >
                  Search
                </CtaButton>
              }
              actionHasPadding={false}
              actionStretchHeight
            />
          </form>
        )}
      </Formik>

      <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>

      {hasSearched && (
        <ShowroomLocatorResults
          loading={loading}
          error={error}
          stores={stores}
          onClose={handleCloseResults}
          isMobile={isMobile}
        />
      )}

      <div className="mt-3">
        <Link
          to="/showrooms/"
          onClick={handleViewAll}
          className="text-brand underline text-sm !font-semibold"
        >
          View All
        </Link>
      </div>
    </div>
  );
};

ShowroomLocatorContent.propTypes = {
  inputId: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ShowroomLocatorContent;
